<template>
    <div id="ranking_table_component"
         class="ranking-table-component">
        <div class="ranking-table-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style3">
                    <tbody>
                        <tr v-for="(name, index) in list"
                            :key="index">
                            <td><p class="name">{{ rowNumber(index) }}. {{ name.login }}</p></td>
                        </tr>
                    </tbody>
                </table>
                <p v-if="list.length == 0" style="margin-top: 25px;">No qualified people.</p>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    export default {
        
        props: ['ranking', 'selected'],
        data () {
            return {
                date: '',
                loader: false,
                items: 25
            }
        },
        computed: {
            list () {
                return this.$store.getters.ranking;
            },
            currentPage () {
                return this.$store.getters.rankingSettings.currentPage;
            },
            maxPerPage () {
                return this.$store.getters.rankingSettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.rankingSettings.numberOfPages;
            },
        },
        methods: {
            /**
             * Get data
             */
            getData () {
                this.loader = true;

                this.$store.commit('rankingSetCareerLevel', this.selected);

                this.$store.dispatch('loadRanking').then(() => {
                    this.loader = false;
                });
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items;
                this.$store.dispatch('rankingSetItems', items).then(() => {
                    this.setPage(1);
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('rankingSetPage', page).then(() => {
                    this.getData();
                });
            },

            /**
             * Get row number
             */
            rowNumber (index) {
                return ((this.currentPage - 1) * this.maxPerPage) + index + 1;
            }
        },
        beforeMount () {
            this.getData();
        },
        watch: {
            selected () {
                this.setPage(1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .name{
        font-size: 17px;
    }

    .ranking-table-component{
        position: relative;

        @media(min-width: 992px){
            margin: 24px 0;
        }
    }

    @media(max-width: 991px){
        .table-outer{
            margin: 0;
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/top-qualified/RankingTable.vue